import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Config from 'configuration';

import { fetchActions } from 'actions/actions';

import PlayerStats from 'components/PlayerStats';
import SidebarQualities from 'components/SidebarQualities';
import ActionCandles from 'components/ActionCandles';

const Sidebar = props => (
  <div className="col-secondary sidebar">
    {(Config.environment === 'local' || Config.environment === 'staging') && (
      <button
        className="button--link"
        style={{ position: 'absolute', top: '-1rem', zIndex: 0 }}
        onClick={() => props.dispatch(fetchActions())}
        type="button"
      >
        <i className="fa fa-refresh" />
      </button>
    )}
    <ActionCandles />
    <PlayerStats />
    <SidebarQualities />
  </div>
);

Sidebar.displayName = 'Sidebar';

Sidebar.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(Sidebar);
